import { AppPage } from 'common/Layout';
import { AppLoader } from 'shared/UI/UIKit/Loader';
import { TeacherWorkloadTable } from 'widgets/teacher-workload-table';
import { useTeacherWorkloadPage } from './use-teacher-workload-page';

export const TeacherWorkloadPage = () => {
  const {
    breadcrumbs,
    breadcrumbsLoading,
    teacherWorkload,
    isPageLoading,
    isTeacherWorkloadRefetching,
  } = useTeacherWorkloadPage();

  return (
    <AppPage
      breadcrumbs={{
        items: breadcrumbs,
        loading: breadcrumbsLoading,
      }}
      documentTitle={teacherWorkload?.code ?? 'Нагрузка учителя'}
    >
      {isPageLoading ? (
        <AppLoader size="large" stretched />
      ) : teacherWorkload ? (
        <TeacherWorkloadTable
          teacherWorkload={teacherWorkload}
          isQueryRefetching={isTeacherWorkloadRefetching}
        />
      ) : null}
    </AppPage>
  );
};
